import React from 'react';

import './Footer.css';

const Footer = () => {
    return <div className="footer__ranjan">
        Made with ❤ By <a href="https://ranjan98.github.io/" className="click__link">Ranjan Goyal</a>
    </div>;
}

export default Footer;